module.exports = __webpack_public_path__ + "static/media/Wine_Class.3b43683d.md";